import { DiscountProvider } from "@redotech/cockroachdb-codegen/congodb/discount-provider";
import { BigcommerceCombineDiscountField } from "./fields/bigcommerce-combine-discount-field";
import { DiscountAmountField } from "./fields/discount-amount-field";
import { ExpirationField } from "./fields/expiration-field";
import { ItemRestrictionsField } from "./fields/item-restrictions-field";
import { MinimumPurchaseAmountField } from "./fields/minimum-purchase-amount-field";
import { MinimumQuantityField } from "./fields/minimum-quantity-field";
import { ShowHiddenRecoverFieldsField } from "./fields/show-hidden-recover-fields-field";
import { DiscountSettingsSectionProps } from "./types";

export function BigcommerceBasicSettings({
  formState,
  category,
  showHiddenRecoverFields,
  setShowHiddenRecoverFields,
}: DiscountSettingsSectionProps) {
  const showRecoverGatedFields = showHiddenRecoverFields;

  return (
    <>
      <DiscountAmountField
        amount={formState.discountAmount}
        setAmount={formState.setDiscountAmount}
        setValueType={formState.setDiscountValueType}
        valueType={formState.discountValueType}
      />
      {showRecoverGatedFields && (
        <ItemRestrictionsField
          collectionIds={formState.collectionIds}
          excludeOnSale={formState.excludeOnSale}
          onExcludeOnSale={formState.handleSetExcludeOnSale}
          provider={DiscountProvider.Bigcommercediscount}
          selectedProducts={formState.selectedProducts}
          setCollectionIds={formState.setCollectionIds}
          setSelectedProducts={formState.setSelectedProducts}
          specifyCollections={formState.specifyCollections}
          specifyProducts={formState.specifyProducts}
        />
      )}
      <BigcommerceCombineDiscountField
        setValue={formState.setCombineDiscountWith}
        value={formState.combineDiscountWith}
      />
      <ExpirationField
        category={category}
        codeGenerationStrategy={formState.codeGenerationStrategy}
        expiration={formState.expiration}
        setExpiration={formState.setExpiration}
      />
      {showRecoverGatedFields && (
        <>
          <MinimumQuantityField
            setValue={formState.handleSetMinimumQuantity}
            value={formState.minimumQuantity}
          />
          <MinimumPurchaseAmountField
            setValue={formState.handleSetMinimumSubtotal}
            value={formState.minimumSubtotal}
          />
        </>
      )}
      <ShowHiddenRecoverFieldsField
        setValue={setShowHiddenRecoverFields}
        value={showHiddenRecoverFields}
      />
    </>
  );
}
